









import { Component, Vue, Prop } from "vue-property-decorator";
import mapboxgl from "mapbox-gl";

@Component({
	components: {},
})
export default class Map extends Vue {
	condominiumPosition: any = [];

	@Prop({ default: null })
	condominium: any;

	async mounted() {
		await this.getPosition(this.condominium);
		// await this.drawMap()
	}

	async getPosition(condominium: any) {
		if (!condominium) return;
		this.$geocoder.setDefaultMode("address");
		var addressObj = {
			address_line_1: condominium.address,
			city: condominium.city,
			zip_code: condominium.zip_code, // postal_code also valid
			country: condominium.country,
		};
		await this.$geocoder.send(addressObj, async (response: any) => {
			this.condominiumPosition = [
				response.results[0].geometry.location.lng,
				response.results[0].geometry.location.lat,
			];
			await this.drawMap();
		});
	}

	async drawMap() {
		mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;
		var lng = this.condominiumPosition[0];
		var lat = this.condominiumPosition[1];

		var map: any = new mapboxgl.Map({
			container: "map-" + this.condominium.id,
			style: process.env.VUE_APP_MAPBOX_STYLE,
			center: [lng, lat], // starting position [lng, lat]
			zoom: 13, // starting zoom
		});

		map.on("load", function () {
			map.loadImage("/geo-pin.png", function (error: any, image: any) {
				if (error) throw error;
				map.addImage("cat", image);

				map.addLayer({
					id: "points",
					type: "symbol",
					source: {
						type: "geojson",
						data: {
							type: "FeatureCollection",
							features: [
								{
									type: "Feature",
									geometry: {
										type: "Point",
										coordinates: [lng, lat],
									},
								},
							],
						},
					},
					layout: {
						"icon-image": "cat",
						"icon-size": 0.25,
					},
				});
			});
		});
	}
}
